import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="cv-seccion" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="cv-titulo-itinerario" />
        <Reveal>
          <ul className="cv-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="cv-itinerario-item" key={i} data-testid={`cv-itinerario-item-${i}`}>
                  <span className="cv-itinerario-hora">{item.hora}</span>
                  <div className="cv-itinerario-cuerpo">
                    <h3 className="cv-itinerario-titulo">
                      <Icono size={14} strokeWidth={1.5} />
                      {item.titulo}
                    </h3>
                    {item.descripcion && <p className="cv-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
